module.exports = __webpack_public_path__ + "static/media/gal06004.a1ce0935.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/gal06/gal06004.jpg
// module id = 479
// module chunks = 0